var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNarrowPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68099 16.236C3.85638 16.412 4.07394 16.5 4.33366 16.5H14.417C14.6767 16.5 14.8946 16.412 15.0706 16.236C15.246 16.0606 15.3337 15.8431 15.3337 15.5833C15.3337 15.3236 15.246 15.1061 15.0706 14.9307C14.8946 14.7547 14.6767 14.6667 14.417 14.6667H4.33366C4.07394 14.6667 3.85638 14.7547 3.68099 14.9307C3.50499 15.1061 3.41699 15.3236 3.41699 15.5833C3.41699 15.8431 3.50499 16.0606 3.68099 16.236Z",
    fill: "#605BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68099 11.6527C3.85638 11.8287 4.07394 11.9167 4.33366 11.9167H11.667C11.9267 11.9167 12.1446 11.8287 12.3206 11.6527C12.496 11.4773 12.5837 11.2597 12.5837 11C12.5837 10.7403 12.496 10.5224 12.3206 10.3464C12.1446 10.171 11.9267 10.0833 11.667 10.0833H4.33366C4.07394 10.0833 3.85638 10.171 3.68099 10.3464C3.50499 10.5224 3.41699 10.7403 3.41699 11C3.41699 11.2597 3.50499 11.4773 3.68099 11.6527Z",
    fill: "#605BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68099 7.07025C3.85638 7.24564 4.07394 7.33333 4.33366 7.33333H14.417C14.6767 7.33333 14.8946 7.24564 15.0706 7.07025C15.246 6.89425 15.3337 6.67639 15.3337 6.41667C15.3337 6.15694 15.246 5.93908 15.0706 5.76308C14.8946 5.58769 14.6767 5.5 14.417 5.5H4.33366C4.07394 5.5 3.85638 5.58769 3.68099 5.76308C3.50499 5.93908 3.41699 6.15694 3.41699 6.41667C3.41699 6.67639 3.50499 6.89425 3.68099 7.07025Z",
    fill: "#605BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.417 8L19.417 11L16.417 14",
    stroke: "#605BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNarrowPurple);
export default __webpack_public_path__ + "static/media/narrow-purple.23d7ae2d81f2401fb4533dd2f2b124cf.svg";
export { ForwardRef as ReactComponent };